export default __webpack_public_path__ + "static/media/undraw_by_the_road_re_vvs7 (1).f45dd428.svg";